/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Prepare_Start_PracticeInputs */

const en_interview_prepare_start_practice = /** @type {(inputs: Interview_Prepare_Start_PracticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start Practice`)
};

const de_interview_prepare_start_practice = /** @type {(inputs: Interview_Prepare_Start_PracticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übung starten`)
};

const fr_interview_prepare_start_practice = /** @type {(inputs: Interview_Prepare_Start_PracticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commencer l'exercice`)
};

const es_interview_prepare_start_practice = /** @type {(inputs: Interview_Prepare_Start_PracticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar práctica`)
};

const it_interview_prepare_start_practice = /** @type {(inputs: Interview_Prepare_Start_PracticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizia esercitazione`)
};

const nl_interview_prepare_start_practice = /** @type {(inputs: Interview_Prepare_Start_PracticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Begin oefening`)
};

const pl_interview_prepare_start_practice = /** @type {(inputs: Interview_Prepare_Start_PracticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozpocznij ćwiczenie`)
};

const fi_interview_prepare_start_practice = /** @type {(inputs: Interview_Prepare_Start_PracticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aloita harjoittelu`)
};

const da_interview_prepare_start_practice = /** @type {(inputs: Interview_Prepare_Start_PracticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start øvelse`)
};

const sv_interview_prepare_start_practice = /** @type {(inputs: Interview_Prepare_Start_PracticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starta övning`)
};

/**
* | output |
* | --- |
* | "Start Practice" |
*
* @param {Interview_Prepare_Start_PracticeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_prepare_start_practice = /** @type {((inputs?: Interview_Prepare_Start_PracticeInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Prepare_Start_PracticeInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_prepare_start_practice(inputs)
	if (locale === "fr") return fr_interview_prepare_start_practice(inputs)
	if (locale === "es") return es_interview_prepare_start_practice(inputs)
	if (locale === "it") return it_interview_prepare_start_practice(inputs)
	if (locale === "nl") return nl_interview_prepare_start_practice(inputs)
	if (locale === "pl") return pl_interview_prepare_start_practice(inputs)
	if (locale === "fi") return fi_interview_prepare_start_practice(inputs)
	if (locale === "da") return da_interview_prepare_start_practice(inputs)
	if (locale === "sv") return sv_interview_prepare_start_practice(inputs)
	return en_interview_prepare_start_practice(inputs)
});